import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import { listFiles } from '../../minio/minioAPI';

// URLs base para los buckets
const VIDEO_BUCKET_URL = process.env.REACT_APP_MINIOURL; // URL del bucket de videos
const THUMBNAIL_BUCKET_URL = process.env.REACT_APP_MINIO_THUMBNAIL_URL; // URL del bucket de miniaturas

const Testimonials = () => {
  const [videos, setVideos] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        // Listar archivos en los buckets de videos y miniaturas
        const videoFiles = await listFiles(VIDEO_BUCKET_URL);
        const thumbnailFiles = await listFiles(THUMBNAIL_BUCKET_URL);

        setVideos(videoFiles);
        setThumbnails(thumbnailFiles);
      } catch (error) {
        console.error('Error fetching files from MinIO:', error);
      }
    };
    fetchFiles();
  }, []);

  // Función para obtener la miniatura correspondiente a un video
  const getThumbnailForVideo = (videoFileName) => {
    const baseName = videoFileName.split('_testimonio')[0]; // Tomar el nombre base del archivo de video

    // Buscar miniaturas que coincidan con el nombre base
    const thumbnailWebp = `${baseName}_miniatura.webp`;
    const thumbnailPng = `${baseName}_miniatura.png`;

    // Verificar si la miniatura existe en el array de miniaturas
    if (thumbnails.includes(thumbnailWebp)) {
      return `${THUMBNAIL_BUCKET_URL}/${thumbnailWebp}`; // Retornar la miniatura .webp si existe
    } else if (thumbnails.includes(thumbnailPng)) {
      return `${THUMBNAIL_BUCKET_URL}/${thumbnailPng}`; // Retornar la miniatura .png si existe
    }

    return null; // Si no se encuentra ninguna miniatura
  };

  return (
    <section className="testimonials">
      <h2>TESTIMONIOS DE CLIENTES</h2>
      <div className="videos">
        {videos.length > 0 ? (
          videos.map((videoFile, index) => (
            <div key={index} className="video-container">
              <video controls poster={getThumbnailForVideo(videoFile)}>
                <source src={`${VIDEO_BUCKET_URL}/${videoFile}`} type="video/mp4" />
                Tu navegador no soporta el elemento de video.
              </video>
            </div>
          ))
        ) : (
          <p>Cargando videos...</p>
        )}
      </div>
    </section>
  );
};

export default Testimonials;
